import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Carousel from './Carousel';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: '100vh',
        width: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      {/* Privacy Policy Link - Bottom Right */}
      <div className="absolute bottom-4 right-4 z-10">
        <Link
          to="/our-privacy-policy"
          className="text-sm text-gray-600 hover:text-gray-800 underline"
        >
          Privacy Policy
        </Link>
      </div>

      <div className="max-w-340 mx-auto px-4 sm:px-6 lg:px-8" style={{ height: '100vh' }}>
        <div className="h-full grid md:grid-cols-2 gap-4 md:gap-8 xl:gap-20 md:items-center">
          <div>
            <h1 className="block text-3xl font-bold text-gray-900 sm:text-4xl lg:text-6xl lg:leading-tight">
              Land your first software engineering internship with <br />
              <img
                src={process.env.PUBLIC_URL + '/maincar.png'}
                alt="Main Car"
                className="inline h-16"
              />{' '}
              <span className="text-blue-600 text-10">InternHub</span>
            </h1>
            <p className="mt-3 text-lg text-gray-700">
              From first time applicant to first time offer.
            </p>
            <div className="mt-7 grid gap-3 w-full sm:inline-flex">
              <button
                onClick={() => {
                  navigate('/login');
                }}
                className="py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-hidden focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
              >
                Get started!
                <svg
                  className="shrink-0 size-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </button>
            </div>
            {/* 
                        <div className="mt-4">
                            <p className="text-sm text-gray-600">Already have an account?</p>
                            <div className="mt-2 flex space-x-4">
                                <Link
                                    to="/login"
                                    className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                >
                                    Sign in with your school
                                </Link>
                            </div>
                        </div> */}
          </div>
          <div className="relative ms-4">
            <div
              style={{
                height: '100vh',
              }}
            >
              <Carousel />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
